module.exports = __webpack_public_path__ + "img/memoirerings-mobile.d349e17.jpg";